import { FC } from 'react';

import { FormControl, FormLabel, Input, SimpleGrid } from '@chakra-ui/react';

type Props = {
  id: number | undefined;
};

/**
 * 編集モーダル用の ID フォーム(readonly)です。
 */
export const IdForm: FC<Props> = ({ id }) => (
  <FormControl>
    <SimpleGrid templateColumns="1fr 2fr">
      <FormLabel>顧客 ID</FormLabel>
      <Input value={id?.toString() ?? ''} disabled />
    </SimpleGrid>
  </FormControl>
);
